import { render, staticRenderFns } from "./FBtn.vue?vue&type=template&id=143b99cd&scoped=true&"
import script from "./FBtn.vue?vue&type=script&lang=ts&"
export * from "./FBtn.vue?vue&type=script&lang=ts&"
import style0 from "./FBtn.vue?vue&type=style&index=0&id=143b99cd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b99cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
